import { LabeledValue, LabeledValue_Label, LabeledValue_Value } from 'emerald-ui';
import React from 'react';
import { parseUtcDate } from '../../utilities/dates';
import { DataHeaderRow_Root } from './DataHeaderRow.style';

/** @typedef {{ type: string, value: string }[]} DataHeaderRowDataProp */

/**
 * @typedef DataHeaderRowProps
 * @property {DataHeaderRowDataProp} [data]
 */

/** @type {(props: DataHeaderRowProps & React.HTMLAttributes<HTMLDivElement>) => JSX.Element} props */
export function DataHeaderRow(props) {
    const {
        data = [],
        ...otherProps
    } = props;

    return (
        <DataHeaderRow_Root {...otherProps}>
            <dl>
                {data.map((item) => (
                    <LabeledValue
                        as='div'
                        data-type={item.type}
                        key={item.type}
                    >
                        <LabeledValue_Label>
                            {item.type}
                        </LabeledValue_Label>
                        <LabeledValue_Value>
                            {parseUtcDate(item.value) || <abbr title='Not available'>n/a</abbr>}
                        </LabeledValue_Value>
                    </LabeledValue>
                ))}
            </dl>
        </DataHeaderRow_Root>
    );
}
